var locale = {
  placeholder: 'Zeit auswählen'
};
export default locale;